/*
 * This file is generated by icons/template.js
 */
const SvgGov = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 22 22" {...props}>
		<path
			fill="#707070"
			fillRule="evenodd"
			d="M5.471 10.254c.367-1.915 2.114-3.327 4.216-3.749V1.306a.75.75 0 0 1 .75-.75h3.547a.75.75 0 0 1 .75.75v.323h2.205l1.773 2.365-1.773 2.364h-3.547v-.755h-2.205v.775c2.576.072 4.912 1.627 5.342 3.876h1.906a.75.75 0 1 1 0 1.5h-.646v1.087h2.586a.75.75 0 0 1 0 1.5h-.97v5.612h.97a.75.75 0 0 1 0 1.5H1.625a.75.75 0 0 1 0-1.5h.763V14.34h-.763a.75.75 0 1 1 0-1.5h2.38v-1.087h-.44a.75.75 0 0 1 0-1.5zM11 7.875c2.04 0 3.545 1.093 3.975 2.38h-7.95c.43-1.287 1.935-2.38 3.975-2.38m2.234-3.772h-2.047V2.056h2.047zm4.671 10.238H15.85v5.612h2.056zm-1.616-2.587v1.087H5.504v-1.087zm-1.94 2.587v5.612h-2.702V14.34zm-4.202 0v5.612H7.444V14.34zm-4.203 5.612V14.34H3.888v5.612zm8.948-16.824h1.297l.648.865-.648.864h-1.297z"
			clipRule="evenodd"
		/>
	</svg>
);
SvgGov.displayName = 'iconGov';
export default SvgGov;
